import axios from 'axios';
import React, { useEffect, useRef } from 'react'

// const baseURL = "http://192.168.0.43:3001"
const baseURL = "http://151.185.45.84:7701"

export default function MultiOTTPayU() {
    const hasCalled = useRef(false);

    useEffect(() => {
        if (hasCalled.current) return; // Prevent second call
        hasCalled.current = true;

        const params = new URL(window.location.href).searchParams;
        const user_id = params.get("user_id");
        const plan_id = params.get("plan_id");
        const ott_id = params.get("ott_id");

        console.log("Parameters", user_id, plan_id, ott_id);

        if (user_id && plan_id && ott_id) {
            paymentInitiatePayU(user_id, plan_id, ott_id);
        }

    }, [])

    const paymentInitiatePayU = async (user_id, plan_id, ott_id) => {
        try {
            const payload = {
                userId: Number(user_id),
                planId: Number(plan_id),
                ottId: Number(ott_id),
            };

            console.log("Payment payload:", payload);

            const resData = await axios.post(
                `${baseURL}/api/v1/payment/payment_gateway_initiate`,
                payload
            );

            console.log("Payment response:", resData.data);

            const form = document.createElement("form");
            form.method = "POST";
            form.action = "https://test.payu.in/_payment";
            // form.action = "https://secure.payu.in/_payment";

            const fields = {
                key: resData?.data?.data?.MERCHANT_KEY,
                txnid: resData?.data?.data?.transactionId,
                amount: resData?.data?.data?.amount,
                productinfo: resData?.data?.data?.productinfo,
                firstname: resData?.data?.data?.firstname,
                email: resData?.data?.data?.email || "harshil.icode49@gmail.com",
                phone: resData?.data?.data?.mobile,
                surl: `${baseURL}/api/v1/payment/payment_gateway_verify`,
                furl: `${baseURL}/api/v1/payment/payment_gateway_verify`,
                hash: resData?.data?.data?.hash_value,
            };

            Object.keys(fields).forEach((key) => {
                const input = document.createElement("input");
                input.type = "hidden";
                input.name = key;
                input.value = fields[key];
                form.appendChild(input);
            });

            document.body.appendChild(form);
            form.submit();



        } catch (error) {
            console.error("Payment API error:", error);

            if (error.response) {
                console.error("Status:", error.response.status);
                console.error("Response:", error.response.data);
            } else if (error.request) {
                console.error("No response received:", error.request);
            } else {
                console.error("Request error:", error.message);
            }
        }
    };

    return (
        <div>MultiOTTPayU</div>
    )
}
